import { Title } from "@clipboard-health/ui-components";

interface OnboardingTitleProps {
  text: string;
}

export function OnboardingTitle({ text }: OnboardingTitleProps) {
  return (
    <Title
      variant="h3"
      component="h1"
      sx={{
        textAlign: "left",
        textWrap: "balance",
      }}
    >
      {text}
    </Title>
  );
}
